import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import { deleteData, fetchData, getCurrentData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;

const columns = [
  { header: "Title", accessor: "title" },
  { header: "Brief Description", accessor: "briefDescription" },
  { header: "Description", accessor: "description" },
];

const ITEMS_PER_PAGE = 10;

const Company = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});
  const { loading, showLoader, hideLoader } = useLoader();

  const {
    showDeleteModal,
    showViewModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.length >= 2 || searchTerm === "") {
      fetchData(
        `${process.env.REACT_APP_API_URL}/company/getAllCompany`,
        setData,
        setError,
        setFilteredData,
        currentPage,
        searchTerm,
        showLoader,
        hideLoader
      );
    }
  }, [currentPage, searchTerm]);

  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2) {
      setSearchTerm(searchValue);
      setCurrentPage(1);
    } else if (searchValue.length === 0) {
      setSearchTerm("");
      setCurrentPage(1);
    }
  };

  const handleDeleteConfirm = () => {
    deleteData(
      `${API_URL}/company/deleteCompanyById`,
      selectedItem._id,
      setError
    )
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => item._id !== selectedItem._id)
        );
        toast.success("Deleted successfully", { autoClose: 1000 });
        fetchData(
          `${API_URL}/company/getAllCompany`,
          setData,
          setError,
          setFilteredData,
          currentPage,
          searchTerm,
          showLoader,
          hideLoader
        );
      })
      .catch((error) => {
        setError(error);
        toast.error("Error deleting data", { autoClose: 1000 });
      });
    handleCloseDeleteModal();
  };

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const currentData = getCurrentData(filteredData, currentPage, ITEMS_PER_PAGE);

  const fieldsToShow = {
    Title: "title",
    "Brief Description": "briefDescription",
    Description: "description",
    Image: "images",
  };

  // Extract unique states and cities for filters
  const states = [...new Set(data.map((d) => d.state))];
  const cities = [...new Set(data.map((d) => d.city))];

  const filterOptions = {
    State: states,
    City: cities,
  };

  return (
    <div>
      <h2 className="capitalize font-bold text-[24px] mb-4">Brands List</h2>

      <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
        <div className="flex items-center">
          <div className="search-filter-container">
            <Search
              searchFields={["First Name", "Last Name", "Email"]}
              onSearch={handleSearch}
            />
          </div>
        </div>

        <Link
          to="/companyManagement/add"
          className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
        >
          Add Brand
        </Link>
      </div>

      <div className="table-container">
        <Table
          columns={columns}
          data={currentData}
          showIndex={true}
          currentPage={currentPage}
          itemsPerPage={ITEMS_PER_PAGE}
          onDelete={handleOpenDeleteModal}
          onUpdate={(item) => navigate(`/companyManagement/edit/${item._id}`)}
          onView={handleOpenViewModal}
          actions={{
            showView: true,
            showEdit: true,
            showDelete: true,
          }}
          loading={loading}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)} // Update current page
        />
      </div>
      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDeleteConfirm}
      />

      <ViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />
    </div>
  );
};

export default Company;
